var map = {
	"./advantages/style.scss": [
		256,
		256
	],
	"./blog/style.scss": [
		268,
		268
	],
	"./hero/style.scss": [
		923,
		923
	],
	"./popular-courses/style.scss": [
		107,
		107
	],
	"./testimonials/style.scss": [
		300,
		300
	],
	"./trust/style.scss": [
		943,
		943
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 47;
module.exports = webpackAsyncContext;